<template>
  <section>
    <h2>DatePicker 日期选择器</h2>
    <p class="desc">选择日期</p>
    <h2>基础用法</h2>
    <div class="container">
      <div class="example">
        <y-date-picker :value="day" @on-change="onChange"></y-date-picker>
      </div>
      <div class="code-wrapper" v-highlight>
        <pre class="code"><code class="html" v-text="text1"></code></pre>
      </div>
    </div>
    <h2>Attributes</h2>
    <div class="attr">
      <table>
        <thead>
          <tr>
            <th>参数</th>
            <th>说明</th>
            <th>类型</th>
            <th>可选值</th>
            <th>默认值</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>value，支持v-model双向绑定</td>
            <td>日期</td>
            <td>String</td>
            <td>--</td>
            <td>当前时间</td>
          </tr>
        </tbody>
      </table>
    </div>
    <h2>DatePicker events</h2>
    <div class="attr">
      <table>
        <thead>
          <tr>
            <th>事件名</th>
            <th>说明</th>
            <th>返回值</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>on-change</td>
            <td>日期选择完成后的回调</td>
            <td>格式化后的时间</td>
          </tr>
        </tbody>
      </table>
    </div>
  </section>
</template>
<script>
export default {
  data () {
    return {
      text1: `<y-date-picker value="2018-09-16"></y-date-picker>`,
      day: '2018-09-16',
    }
  },
  methods: {
    onChange (val) {
      console.log(val)
    },
  },
}
</script>
